import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getUserLogs = ({
  churchId,
  isDenomination = false,
  denominationId,
  userId
}) => {
  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/logs/${userId}`
  );
};

export const useUserLogs = ({
  churchId,
  isDenomination = false,
  denominationId,
  userId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["user-logs", userId, isDenomination ? denominationId : churchId],
    queryFn: () =>
      getUserLogs({ churchId, isDenomination, denominationId, userId })
  });
};
